/**
 * Sidebar Store - Manage sidebar visibility and state
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarState {
  isOpen: boolean;
  isMinimized: boolean;
  
  // Actions
  toggleSidebar: () => void;
  openSidebar: () => void;
  closeSidebar: () => void;
  toggleMinimize: () => void;
  setMinimized: (minimized: boolean) => void;
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set, get) => ({
      isOpen: false, // Desktop default: closed (open only when user clicks "Projekty")
      isMinimized: false,

      toggleSidebar: () => {
        set((state) => ({ isOpen: !state.isOpen }));
      },

      openSidebar: () => {
        set({ isOpen: true });
      },

      closeSidebar: () => {
        set({ isOpen: false });
      },

      toggleMinimize: () => {
        set((state) => ({ isMinimized: !state.isMinimized }));
      },

      setMinimized: (minimized: boolean) => {
        set({ isMinimized: minimized });
      },
    }),
    {
      name: 'sidebar-storage',
    }
  )
);

